import { createContext } from "react";
import {EduWeb3Provider} from "./provider";

export const Web3ProviderInstance = new EduWeb3Provider()
export const Web3Context = createContext<EduWeb3Provider>(Web3ProviderInstance)

